<div *ngFor="let review of reviews; let i = index;" class="review-box">
  <app-review [review]="review" (onEdit)="onEditReview(review)" (needAuth)="needAuth.emit()"></app-review>
</div>

<div class="plus-review" [class.plus-review-left]="!showNewReview && (!reviews || reviews.length == 0)" *ngIf="!showNewReview" (click)="openNewReview()">
  <img alt="Add Review Button" class="add-btn" src="./assets/images/add_button_circled.png">
  {{getString('writeReview')}}
</div>

<div *ngIf="showNewReview" class="new-review">
  <input type="text" [(ngModel)]="newReviewTitle" [placeholder]="getString('newReviewTitlePlaceholder')">
  <textarea [(ngModel)]="newReviewText" [placeholder]="getString('newReviewTextPlaceholder')"></textarea>
  <div class="btns-container">
    <select [(ngModel)]="newReviewRating">
      <option value="0">{{getString('starNote')}}</option>
      <option value="1">⭐ 1</option>
      <option value="2">⭐⭐ 2</option>
      <option value="3">⭐⭐⭐ 3</option>
      <option value="4">⭐⭐⭐⭐ 4</option>
      <option value="5">⭐⭐⭐⭐⭐ 5</option>
      <option value="6">⭐⭐⭐⭐⭐⭐ 6</option>
      <option value="7">⭐⭐⭐⭐⭐⭐⭐ 7</option>
      <option value="8">⭐⭐⭐⭐⭐⭐⭐⭐ 8</option>
      <option value="9">⭐⭐⭐⭐⭐⭐⭐⭐⭐ 9</option>
      <option value="10">⭐⭐⭐⭐⭐⭐⭐⭐⭐⭐ 10</option>
    </select>
    <button type="button" class="blue-button add-review-btn" (click)="send()">{{getString('send')}}</button>
    <button type="button" class="blue-button cancel-review-btn" (click)="cancelReview()">{{getString('cancel')}}</button>
  </div>
</div>